import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import ErrorBoundaryWrapper from '../../ErrorFallback/ErrorBoundaryWrapper';

import VoteButton from '../components/VoteButton';
import getPlayerOfTheGameState from '../store/selectors/getPlayerOfTheGameState';

const VoteButtonDataContainer = (props) => {
    const { showPOTG, blockLoginActivities, ...otherStateProps } = useSelector(getPlayerOfTheGameState);
    if (!showPOTG || blockLoginActivities) {
        return null;
    }

    return (
        <ErrorBoundaryWrapper componentName='Player of The Game Voting Button'>
            <VoteButton {...otherStateProps} {...props} />
        </ErrorBoundaryWrapper>
    );
};

export default memo(VoteButtonDataContainer);
